import css from 'styled-jsx/css';

export const CharacListCss = css`
  .CharacList {
    padding: 2.5rem 0;
    :global(.CharacList__title) {
      margin-bottom: 2rem;
    }
    &__list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 3rem 1rem;
      &--THREE_COLUMNS {
        flex-wrap: wrap;
      }
    }
    &__item {
      text-align: center;
      &--ALL_IN_LINE {
        max-width: 250px;
      }
      &--THREE_COLUMNS {
        width: 30%;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .CharacList {
      &__item {
        width: 100%;
        max-width: inherit;
      }
    }
  }
`;
